import { ISelectionChangeArgs } from "@components/inputs/select/Select.types";
import React, { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { addCompanyIdToUrl } from "../../../contexts/appContext/AppContext.utils";
import { AvatarSize, TextAlign } from "../../../enums";
import { Title } from "../../../global.style";
import { ROUTE_HOME } from "../../../routes";
import TestIds from "../../../testIds";
import Avatar from "../../avatar";
import { CaretIcon } from "../../icon";
import IconSelect from "../../inputs/select/IconSelect";
import { companyToSelectItem } from "./CompanySelector";
import { CustomerCompanySelectorWrapper } from "./Selector.styles";
import { WithCompanySelector, withCompanySelector } from "./withCompanySelector";

interface IProps extends WithCompanySelector {
}

const CustomerCompanySelectorBase: React.FC<IProps> = ({ company, companies, logo, handleCompanyChange }) => {
    const history = useHistory();
    const handleCompanySelect = useCallback((args: ISelectionChangeArgs) => {
        handleCompanyChange(args.value as number);

        if (args.value as number !== company?.Id) {
            history.replace(addCompanyIdToUrl(ROUTE_HOME, args.value as number));
        }
    }, [company?.Id, handleCompanyChange, history]);

    const items = useMemo(() => companies.map(companyToSelectItem), [companies]);

    if (!company) {
        return null;
    }
    const columns = [{ textAlign: TextAlign.Left }, { textAlign: TextAlign.Right }];

    return (
            <CustomerCompanySelectorWrapper data-testid={TestIds.CustomerCompanySelector}>
                <Avatar src={logo}
                        size={AvatarSize.almostM}
                        isRound/>
                <Title data-testid={TestIds.HeaderTitle}>
                    {company.Name}
                </Title>
                {items.length > 1 && (
                        <IconSelect items={items}
                                    hotspotId={"CustomerCompanySelectorItems"}
                                    value={company.Id}
                                    columns={columns}
                                    icon={<CaretIcon/>}
                                    iconButtonProps={{
                                        isLight: false,
                                        isTransparent: true
                                    }}
                                    onChange={handleCompanySelect}
                                    showSearchBoxInMenu={false}/>
                )}
            </CustomerCompanySelectorWrapper>
    );
};

const extendedCustomerCompanySelector = withCompanySelector({
    isCustomerPortal: true,
    showOnlyInitialised: true
})(CustomerCompanySelectorBase);
export { extendedCustomerCompanySelector as CustomerCompanySelector };